<template>
  <ul role="list" class="divide-y divide-gray-100">
    <li v-for="solicitacao in solicitacoes" :key="solicitacao.id" class="flex items-center justify-between gap-x-6 py-5">
        <div class="min-w-0">
            <div class="flex items-start gap-x-3">
            <p class="text-sm/6 font-semibold text-gray-900">{{ solicitacao.titulo }}</p>
            <p :class="[statuses[solicitacao.status], 'mt-0.5 whitespace-nowrap rounded-md px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset']">
                {{ solicitacao.status }}
            </p>
            </div>

            <div class="mt-1 flex flex-col gap-y-1 text-xs text-gray-500">
            <p class="whitespace-nowrap">Criada em {{ formatDateTime(solicitacao.created_at) }}</p>
            <p class="truncate">Solicitada por, {{ solicitacao.solicitante_email }}</p>
            <p class="truncate">para, {{ solicitacao.solicitado_email }}</p>

            <!-- TEXTO EXTRA SE FOR CANCELADA -->
            <template v-if="solicitacao.status === 'cancelada'">
                <p class="text-red-600 font-semibold">Cancelada por {{ solicitacao.cancelada_por_email }}</p>
                <p class="text-red-500 italic">Motivo: {{ solicitacao.motivo_cancelamento }}</p>
            </template>

            <!-- TEXTO EXTRA SE FOR ATENDIDA -->
            <template v-else-if="solicitacao.status === 'atendida'">
                <p class="text-green-600 font-semibold">Respondida por {{ solicitacao.atendida_por_email }}</p>
                <p class="text-green-500 italic">Resposta: {{ solicitacao.resposta }}</p>
            </template>
            </div>
        </div>

        <!-- BOTÕES SE NÃO CANCELADA -->
        <div v-if="solicitacao.status === 'pendente'" class="flex flex-none items-center gap-x-4">
            <button @click="atender(solicitacao.id)" type="button" class="hidden rounded-md bg-customPurple px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm ring-1 ring-inset hover:bg-sienaBlue sm:block">
                Atender
            </button>
            <button @click="cancelar(solicitacao.id)"  type="button" class="hidden rounded-md bg-red-100 px-2.5 py-1.5 text-sm font-semibold text-red-700 shadow-sm ring-1 ring-inset ring-red-300 hover:bg-red-200 sm:block">
                Cancelar
            </button>
        </div>
        </li>
  </ul>
</template>

<script>

  export default {
    name: 'SolicistacoesList',
    emits:['handle-request','cancel-request'],
    async created(){},
    props: {
      solicitacoes:{
        type:Array,
        required:true
      }
    },  
    watch: {
      
    }, 
    data() {
      return {
        statuses: {
            atendida: 'text-green-700 bg-green-50 ring-green-600/20',
            'pendente': 'text-gray-600 bg-gray-50 ring-gray-500/10',
            cancelada: 'text-red-800 bg-red-50 ring-red-600/20',
        },
      }
    },
    methods: {
        formatDateTime(datetime) {
            if (!datetime) return '';
            const date = new Date(datetime);
            return new Intl.DateTimeFormat('pt-BR', {
            dateStyle: 'short',
            timeStyle: 'short',
            timeZone: 'America/Sao_Paulo'
            }).format(date);
        },
        atender(data){
          let payload = {
            id: data,
            tipo:'atender'
          }
          this.$emit('handle-request', payload); 
        },
        cancelar(data){
          let payload = {
            id: data,
            tipo:'cancelar'
          }
          this.$emit('cancel-request', payload); 
        }
    },
    components:{
    },
  }
</script>